import React from 'react'
import { createRoot } from 'react-dom/client'
import { useAtomValue } from 'jotai'
import { ThemeProvider } from '@/context/ThemeContext'
import { windowWorkspaceIdAtom } from '@/atoms/sessions'
import App from './App'
import './index.css'

function Root() {
  const workspaceId = useAtomValue(windowWorkspaceIdAtom)

  return (
    <ThemeProvider activeWorkspaceId={workspaceId}>
      <App />
    </ThemeProvider>
  )
}

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)
